import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '@tds/core-button-group';

import { Box } from '../design/css';
import { ButtonWrapper } from './css';

const DateFiltersButtons = ({
  filterCriteria,
  updateFilters,
  filterLabels,
  showCompletedAt
}) => (
  <Box>
    <ButtonWrapper>
      <ButtonGroup
        name="filterDates"
        label=" "
        onChange={e => updateFilters('filterCriteria', e.target.value)}
        value={filterCriteria}
      >
        <ButtonGroup.Item value="createdAt">
          {filterLabels.openedDate}
        </ButtonGroup.Item>
        {showCompletedAt ? (
          <ButtonGroup.Item value="completedAt">
            {filterLabels.completedDate}
          </ButtonGroup.Item>
        ) : (
          <></>
        )}
      </ButtonGroup>
    </ButtonWrapper>
  </Box>
);

DateFiltersButtons.propTypes = {
  filterCriteria: PropTypes.string.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterLabels: PropTypes.shape({
    openedDate: PropTypes.string,
    completedDate: PropTypes.string
  }).isRequired,
  showCompletedAt: PropTypes.bool
};

DateFiltersButtons.defaultProps = {
  showCompletedAt: true
};

export default DateFiltersButtons;
